module.exports = __webpack_public_path__ + "img/simpleVector.9832d53e.svg";